<template>
  <div class="wrapper" :class="{'nav-open': $sidebar.showSidebar}">
    <notifications></notifications>
    <side-bar>
      <mobile-menu></mobile-menu>
      <template slot="links">
        <sidebar-item @dashLoading="dashLoading" :link="{name: 'Dashboard #1', icon: 'nc-icon nc-chart-pie-35', path: '/demos/dashboard1'}">
        </sidebar-item>
        <sidebar-item @dashLoading="dashLoading" :link="{name: 'Dashboard #2', icon: 'nc-icon nc-chart-pie-35', path: '/demos/dashboard2'}">
        </sidebar-item>
        <span v-for="modul in modules" :key="modul.name_module + modul.icon">
          <sidebar-item
            v-if="modul.level == 1"
            @dashLoading="dashLoading"
            :link="{name: modul.name_module,
                    icon: modul.icon,
                    path: modul.url}">
                <sidebar-item
                  v-for="mod in modul.children" :key="mod.name_module + mod.icon"
                  @dashLoading="dashLoading"
                  :link="{name: mod.name_module,
                          icon: mod.icon,
                          path: mod.url}">
                </sidebar-item>
          </sidebar-item>
        </span>
      </template>
    </side-bar>
    <div class="main-panel">
      <top-navbar @dashLoading="dashLoading"></top-navbar>
      <loading :active.sync="isDashLoading"
        :can-cancel="false"
        :color="'#f18f00'"
        :is-full-page="false"
        :height="100"
        :width="255"
        :opacity="0.8">
      </loading>
      <dashboard-content @click.native="toggleSidebar" @dashLoading="dashLoading" >
      </dashboard-content>
      <content-footer></content-footer>
    </div>
    <a href="#" class="float" @click.prevent="topPage">
      <i class="fa fa-arrow-up my-float"></i>
    </a>
  </div>
</template>
<script>
  import TopNavbar from './TopNavbar.vue'
  import ContentFooter from './ContentFooter.vue'
  import DashboardContent from './Content.vue'
  import MobileMenu from './MobileMenu.vue'
  import swal from 'sweetalert2'
  import store from '@/store'
  import mixinPermissions from 'src/util/mixinPermissions'
  import Loading from 'vue-loading-overlay';
  import 'vue-loading-overlay/dist/vue-loading.css';

  export default {
    components: {
      TopNavbar,
      ContentFooter,
      DashboardContent,
      MobileMenu,
      Loading
    },
    data () {
      return {
        isDashLoading: null,
        modules: []
      }
    },
    mixins: [mixinPermissions],
    methods: {
      dashLoading (value) {
        this.isDashLoading = value
      },
      toggleSidebar () {
        if (this.$sidebar.showSidebar) {
          this.$sidebar.displaySidebar(false)
        }
      },
      topPage(){
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
      },
    },
    created(){
      localStorage.setItem('urlModule', this.$route.path)
      this.modules = this.$store.state.auth.user.modules
      store.dispatch('auth/validatePassTime', store.state.auth.user.id)

      let exists = false

      for (let index = 0; index < this.$store.state.auth.user.modules_urls.length; index++) {
        if (this.$route.path.includes(this.$store.state.auth.user.modules_urls[index])) {
          exists = true
          break
        }
      }

      if (!exists) this.showMessageAccess()
      else {
        if (this.$route.path.includes('create') && !this.canCreate()) this.showMessageAccess()
      }
    },
    mounted(){
      setTimeout(() => {
        this.isDashLoading = false
      }, 30000);
    }
  }
</script>
